// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#context_bar_middle {
  flex: 1 !important;
  flex-shrink: 3 !important;
}

#context_bar_right {
  flex-shrink: 3 !important;
}

/*   TODO(mdc-migration): The following rule targets internal classes of progress-bar that may no longer apply for the MDC version.*/
mat-progress-bar {
  width: 100%;
  position: absolute;
}

/*   TODO(mdc-migration): The following rule targets internal classes of progress-bar that may no longer apply for the MDC version.*/
::ng-deep .mat-progress-bar-fill::after {
  background-color: #51738b;
}

/*   TODO(mdc-migration): The following rule targets internal classes of progress-bar that may no longer apply for the MDC version.*/
::ng-deep .mat-progress-bar-buffer {
  background-color: #7b9cb3;
}`, "",{"version":3,"sources":["webpack://./src/app/components/results/results-header/context-bar.component.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,yBAAA;AACF;;AAEA;EACE,yBAAA;AACF;;AAEA,oIAAA;AACA;EACE,WAAA;EACA,kBAAA;AACF;;AAEA,oIAAA;AACA;EAEE,yBAAA;AAAF;;AAIA,oIAAA;AACA;EAGE,yBAAA;AAHF","sourcesContent":["#context_bar_middle {\r\n  flex: 1 !important;\r\n  flex-shrink: 3 !important;\r\n}\r\n\r\n#context_bar_right {\r\n  flex-shrink: 3 !important;\r\n}\r\n\r\n/*   TODO(mdc-migration): The following rule targets internal classes of progress-bar that may no longer apply for the MDC version.*/\nmat-progress-bar {\r\n  width: 100%;\r\n  position: absolute;\r\n}\r\n\r\n/*   TODO(mdc-migration): The following rule targets internal classes of progress-bar that may no longer apply for the MDC version.*/\n::ng-deep .mat-progress-bar-fill::after {\r\n//   // background-color: #1E457C;\r\n  background-color: #51738b;\r\n  // color: #51738b;\r\n}\r\n\r\n/*   TODO(mdc-migration): The following rule targets internal classes of progress-bar that may no longer apply for the MDC version.*/\n::ng-deep .mat-progress-bar-buffer {\r\n  // background: #E4E8EB;\r\n  // background: #51738b7c;\r\n  background-color: #7b9cb3;\r\n\r\n}\r\n\r\n// ::ng-deep .mat-progress-bar {\r\n//   border-radius: 2px;\r\n// }\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
